<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open">
  <div class="esf-main-sidebar__content" *ngIf="attributeService.createAttributeModal">
    <h3 i18n='Section title@@clubComponent.heading.createAttribute'>Create attribute</h3>
    <form [formGroup]="attributeForm" (ngSubmit)="submitAttributeCreate(attributeForm)" id="attributeCreateForm">
      <div app-form-field-text-generic
           [control]="attributeForm.get('name')"
           [placeholder]="flTranslations.i18nName"
           [label]="flTranslations.i18nName">
      </div>
      <div app-form-field-text-generic
           [optional]="true"
           [control]="attributeForm.get('description')"
           [placeholder]="flTranslations.i18nDescription"
           [label]="flTranslations.i18nDescription">
      </div>

      <div app-form-field-color-picker
           [control]="attributeForm.get('color')"
           [label]="flTranslations.i18nColor">
      </div>

      <div app-form-field-select
           *ngIf="!selectedClub.isDataFeedActive"
           [control]="attributeForm.get('syncTixxPool')"
           (valueChanged)="attributeForm.get('customerPoolGroupId').patchValue(null)"
           [label]="flTranslations.i18nSyncWithTixxCustomerPool"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-number
           *ngIf="attributeForm.get('syncTixxPool')?.value && !selectedClub.isDataFeedActive"
           [isCurrency]="false"
           [control]="attributeForm.get('customerPoolGroupId')"
           [placeholder]="flTranslations.i18nCustomerPoolId"
           [label]="flTranslations.i18nCustomerPoolId">
      </div>

      <div app-form-field-select
           [control]="attributeForm.get('assignable')"
           [label]="flTranslations.i18nAttributionCustomerProfile"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div class="esf-form-item">
        <label i18n='Form label text@@general.formLabel.active' class="esf-form-item__label">Active</label>
        <div class="esf-toggle">
          <input class="esf-toggle__input" type="checkbox" name="status" id="status" formControlName="status">
          <label class="esf-toggle__label" for="status">
            <div class="esf-toggle__button">
              <div class="esf-toggle__button-background">
                <div class="esf-toggle__button-handle"></div>
              </div>
            </div>
          </label>
        </div>
      </div>

    </form>
  </div>

  <div class="esf-main-sidebar__content" *ngIf="attributeService.editAttributeModal">
    <h3 i18n='Section title@@clubComponent.heading.editAttribute'>Edit attribute</h3>
    <form [formGroup]="attributeForm" (ngSubmit)="submitAttributeEdit(attributeForm)" id="attributeEditForm">
      <div app-form-field-text-generic
           [control]="attributeForm.get('name')"
           [placeholder]="flTranslations.i18nName"
           [label]="flTranslations.i18nName">
      </div>
      <div app-form-field-text-generic
           [optional]="true"
           [control]="attributeForm.get('description')"
           [placeholder]="flTranslations.i18nDescription"
           [label]="flTranslations.i18nDescription">
      </div>

      <div app-form-field-color-picker
           [control]="attributeForm.get('color')"
           [label]="flTranslations.i18nColor">
      </div>

      <div app-form-field-select
           *ngIf="!selectedClub.isDataFeedActive"
           [control]="attributeForm.get('syncTixxPool')"
           (valueChanged)="attributeForm.get('customerPoolGroupId').patchValue(null)"
           [label]="flTranslations.i18nSyncWithTixxCustomerPool"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-number
           *ngIf="attributeForm.get('syncTixxPool')?.value && !selectedClub.isDataFeedActive"
           [isCurrency]="false"
           [control]="attributeForm.get('customerPoolGroupId')"
           [placeholder]="flTranslations.i18nCustomerPoolId"
           [label]="flTranslations.i18nCustomerPoolId">
      </div>

      <div app-form-field-select
           [control]="attributeForm.get('assignable')"
           [label]="flTranslations.i18nAttributionCustomerProfile"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div class="esf-form-item">
        <label i18n='Form label text@@general.formLabel.active' class="esf-form-item__label">Active</label>
        <div class="esf-toggle">
          <input class="esf-toggle__input" type="checkbox" name="status" id="status" formControlName="status">
          <label class="esf-toggle__label" for="status">
            <div class="esf-toggle__button">
              <div class="esf-toggle__button-background">
                <div class="esf-toggle__button-handle"></div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </form>

  </div>

</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <div class="esf-submit-row">
    <div class="esf-submit-row__item">
      <button
              class="esf-button esf-button--standard esf-button--filled"
              *ngIf="attributeService.createAttributeModal"
              i18n="General submit button@@general.button.submit"
              form="attributeCreateForm">Submit</button>
      <button
              class="esf-button esf-button--standard esf-button--filled"
              *ngIf="attributeService.editAttributeModal"
              i18n="General submit button@@general.button.submit"
              form="attributeEditForm">Submit</button>
      <div *ngIf="updateDataLoading" class="esf-spinner flex-container">
        <div class="row">
          <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
          <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
          <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
        </div>
      </div>
    </div>
    <div class="esf-submit-row__item">
      <button class="esf-button esf-button--standard esf-button--outlined esf-js-workingSpaceToggle"
              i18n="General back button@@general.button.back"
              (click)="attributeService.toggleAllModals(false)">Back</button>
    </div>
  </div>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open" (click)="attributeService.toggleAllModals(false)">
  <span class="esf-hamburger__icon"></span>
</div>
